<script setup lang="ts">
import { PickupStep } from '~/lib/models/ui/modal-steps'
import { CounterType } from '~/lib/services/store/order/order.dto'
import { GTMContentGroup } from '~/lib/models/gtm'

defineProps<{
  counters: CounterType[]
}>()

const { trackPageView } = useGTM()
const emit = defineEmits(['set-step', 'set-counter', 'close'])

const setCounter = (counter: CounterType) => {
  const event = { counter }
  emit('set-counter', event)
}

onMounted(() => {
  trackPageView(
    {
      cg: GTMContentGroup.primary.ECOMMERCE,
      cg2: GTMContentGroup.secondary.ORDER,
      cg3: GTMContentGroup.tertiary.PICKUP_METHOD_COUNTER,
    },
    true
  )
})
</script>

<template>
  <main data-test="pickup-counter-selection">
    <ModalCenter :add-close-button="false">
      <template #header>
        <div class="flex w-full flex-row">
          <img
            class="h-8 cursor-pointer md:h-6"
            src="/images/icons/arrowLeft.svg"
            alt="back"
            @click="emit('set-step', PickupStep.AREA_SELECTION)"
          />
        </div>
      </template>

      <template #content>
        <section class="mx-auto w-full p-4 md:w-[85%] md:p-0">
          <LazyCounter :counters="counters" @select-counter="setCounter" />
        </section>
      </template>
    </ModalCenter>
  </main>
</template>
